import CorporateIcon from 'components/icons/Corporate'
import UserDefaultIcon from 'components/icons/UserDefaultIcon'
import InfoCards from 'components/InfoCards'
import {
  CardRow,
  SectionWrapper,
  TopHeader,
  TopHeading,
} from 'modules/Dashboard/Style/style'
import DriveIcon from 'modules/Nav/icons/DriveIcon'
import React, { useEffect, useRef, useState } from 'react'

import DrivesInfoTable from 'modules/Dashboard/Partials/DrivesInfoTable'
import DriveTabs from 'modules/Dashboard/Partials/DriveTabs'
import { COLORS } from 'theme'

const Dashboard = ({ getDashboardDriveList, dashboardDriveList }) => {
  const [page, setPage] = useState(1)
  const tableRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [cardsData, setCardsData] = useState([])
  const [selectionType, setSelectionType] = useState('UPCOMING')
  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('asc')
  const changeState = type => {
    setPage(1)
    setSelectionType(type)
    setSortBy('')
    setOrderBy('asc')
    setSearch('')
  }
  useEffect(() => {
    getDashboardDriveList({
      page,
      search,
      selectionType,
      sortBy,
      orderBy,
      setLoading,
    })
  }, [page, search, selectionType, sortBy, orderBy])

  useEffect(() => {
    const cardData = [
      {
        key: 1,
        icon: <DriveIcon color={'#3249D7'} />,
        text: 'Total Drives',
        value: dashboardDriveList?.driveCount,
        isSelected: false,
      },
      {
        key: 2,
        icon: <DriveIcon color={'#3249D7'} />,
        text: 'Drive active',
        value: dashboardDriveList?.activeDriveCount,
        isSelected: false,
      },
      {
        key: 3,
        icon: <UserDefaultIcon />,
        text: 'Students applied / Active',
        value: dashboardDriveList?.totalActiveUniqueCandidatesCount,
        filter: '1',
        isSelected: false,
      },
      {
        key: 4,
        icon: <CorporateIcon />,
        text: 'Corporate actively hiring',
        value: dashboardDriveList?.activelyHriringCorporateCount,
        filter: '0',
        isSelected: false,
      },
    ]
    setCardsData(cardData)
  }, [dashboardDriveList])

  return (
    <SectionWrapper column>
      <TopHeader row spaceBetween alignCenter ref={tableRef}>
        <TopHeading flexStart>Corporate List</TopHeading>
      </TopHeader>
      <CardRow spaceBetween>
        {cardsData?.map(card => (
          <InfoCards
            padding={'20px'}
            width={'25%'}
            icon={card?.icon}
            text={card?.text}
            value={card?.value}
            background={card?.isSelected ? COLORS.BLUE_T_50 : COLORS.BLUE_T_95}
            isSelected={card?.isSelected}
          />
        ))}
      </CardRow>

      <DriveTabs
        selected={selectionType}
        selectedType={type => {
          changeState(type)
        }}
        pastDriveCount={dashboardDriveList?.pastDriveCount}
        upcominngDriveCount={dashboardDriveList?.upcominngDriveCount}
        onGoingDriveCount={dashboardDriveList?.activeDriveCount}
      />
      <br></br>
      <DrivesInfoTable
        dashboardDriveList={dashboardDriveList}
        currentPage={page}
        setCurrentPage={setPage}
        loading={loading}
        search={search}
        setSearch={setSearch}
        sortBy={sortBy}
        setSortBy={setSortBy}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        selectionType={selectionType}
      />
    </SectionWrapper>
  )
}
export default Dashboard
